import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventName'
})
export class EventNamePipe implements PipeTransform {
  transform(eventKey: string | undefined, translations: Record<string, { translateName: string }>): string {
    if (!eventKey || !translations) {
      return eventKey || '';
    }
    return translations[eventKey]?.translateName || eventKey;
  }
}